(() => {
  const desktopMq = window.matchMedia('(min-width: 990px)');

  function closeMenu(menu) {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');

    if (!details || !summary) return;

    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  }

  function openMenu(menu, allMenus) {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');

    if (!details || !summary) return;

    allMenus.forEach((otherMenu) => {
      if (otherMenu !== menu) closeMenu(otherMenu);
    });

    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  }

  function initHeaderMenuHover() {
    const menus = document.querySelectorAll('header-menu');

    menus.forEach((menu) => {
      if (menu.dataset.hoverReady === 'true') return;
      menu.dataset.hoverReady = 'true';

      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');

      if (!details || !summary) return;

      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        if (!desktopMq.matches) return;
        clearTimeout(closeTimer);
        openMenu(menu, menus);
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktopMq.matches) return;

        closeTimer = setTimeout(() => {
          closeMenu(menu);
        }, 120);
      });

      summary.addEventListener('click', (event) => {
        if (!desktopMq.matches) return;

        const url = summary.dataset.url;

        // clic souris uniquement
        if (event.detail === 0) return;

        if (url && url !== '#' && url !== window.location.pathname) {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = url;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHeaderMenuHover);
  document.addEventListener('shopify:section:load', initHeaderMenuHover);
})();